import * as React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function LoadingSpinner() {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "100vh",
				backgroundColor: "#f5f5f5",
			}}
		>
			<CircularProgress size={60} thickness={4} />
			<Typography
				variant="h6"
				sx={{
					marginTop: 2,
					color: "text.secondary",
				}}
			>
				Loading...
			</Typography>
		</Box>
	);
}
